import {
  AppleLogo,
  Archive,
  ArrowBendDoubleUpRight,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowFatLineDown,
  ArrowFatLineUp,
  ArrowLeft,
  ArrowRight,
  ArrowsClockwise,
  ArrowsDownUp,
  ArrowsIn,
  ArrowsInLineHorizontal,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOut,
  ArrowsOutLineHorizontal,
  ArrowsOutSimple,
  ArrowSquareOut,
  ArrowSquareRight,
  ArrowUp,
  ArrowUUpRight,
  Article,
  Bank,
  Bell,
  Briefcase,
  BugDroid,
  Buildings,
  CalendarBlank,
  CalendarCheck,
  CalendarDots,
  CalendarPlus,
  Cardholder,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  Certificate,
  Champagne,
  ChartLine,
  ChatDots,
  Chats,
  ChatText,
  Check,
  CheckCircle,
  CheckSquare,
  Circle,
  CircleNotch,
  ClipboardText,
  Clock,
  ClockClockwise,
  ClockCounterClockwise,
  CodeBlock,
  Copy,
  CreditCard,
  CurrencyCircleDollar,
  DeviceMobile,
  Dot,
  DotOutline,
  DotsSixVertical,
  DotsThree,
  DotsThreeVertical,
  DownloadSimple,
  Envelope,
  EnvelopeSimpleOpen,
  Eye,
  EyeClosed,
  File,
  FileDoc,
  FileLock,
  FileMinus,
  FilePdf,
  FilePlus,
  Files,
  FileText,
  FileX,
  FileXls,
  FlagCheckered,
  Flask,
  FolderLock,
  FolderNotch,
  FolderOpen,
  FolderPlus,
  Folders,
  Gavel,
  Gear,
  Gift,
  GitCommit,
  GitFork,
  Globe,
  GoogleLogo,
  Graph,
  GridNine,
  Hand,
  Handshake,
  Hash,
  Hourglass,
  House,
  HouseLine,
  IdentificationCard,
  Info,
  Lightbulb,
  Lightning,
  LightningA,
  Link,
  List,
  ListBullets,
  ListChecks,
  ListMagnifyingGlass,
  ListNumbers,
  ListPlus,
  ListStar,
  LockKey,
  LockSimple,
  MagicWand,
  MagnifyingGlass,
  MagnifyingGlassMinus,
  MagnifyingGlassPlus,
  MapPin,
  MapPinSimpleArea,
  Megaphone,
  MicrosoftExcelLogo,
  MicrosoftOutlookLogo,
  Minus,
  Money,
  Monitor,
  Notebook,
  NotePencil,
  PaintBrush,
  PaintBrushBroad,
  Paperclip,
  PaperPlaneTilt,
  Parachute,
  Peace,
  Pen,
  PencilSimple,
  Person,
  Phone,
  Plugs,
  Plus,
  PottedPlant,
  Printer,
  Question,
  Receipt,
  RocketLaunch,
  Rows,
  Scroll,
  SealCheck,
  ShoppingCartSimple,
  SidebarSimple,
  Signature,
  SignOut,
  SortAscending,
  SortDescending,
  Sparkle,
  StackMinus,
  Star,
  SuitcaseSimple,
  Swap,
  Table,
  TextAlignLeft,
  TextBolder,
  TextItalic,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Unite,
  UploadSimple,
  User,
  UserCircle,
  UserCircleGear,
  UserCirclePlus,
  UserList,
  UserMinus,
  UserPlus,
  Users,
  UserSquare,
  UsersThree,
  UserSwitch,
  VideoCamera,
  Wallet,
  Warning,
  WarningCircle,
  Webcam,
  X,
  XCircle,
  XSquare,
} from "@phosphor-icons/react";

export const iconMap = {
  "apple-logo": <AppleLogo />,
  archive: <Archive />,
  "arrow-bend-double-up-right": <ArrowBendDoubleUpRight />,
  "arrow-clockwise": <ArrowClockwise />,
  "arrow-counter-clockwise": <ArrowCounterClockwise />,
  "arrow-down": <ArrowDown />,
  "arrows-down-up": <ArrowsDownUp />,
  "arrow-fat-line-down": <ArrowFatLineDown />,
  "arrow-fat-line-up": <ArrowFatLineUp />,
  "arrow-left": <ArrowLeft />,
  "arrow-right": <ArrowRight />,
  "arrow-square-out": <ArrowSquareOut />,
  "arrow-square-right": <ArrowSquareRight />,
  "arrow-u-up-right": <ArrowUUpRight />,
  "arrow-up": <ArrowUp />,
  "arrows-clockwise": <ArrowsClockwise />,
  "arrows-in": <ArrowsIn />,
  "arrows-in-line-horizontal": <ArrowsInLineHorizontal />,
  "arrows-in-simple": <ArrowsInSimple />,
  "arrows-left-right": <ArrowsLeftRight />,
  "arrows-out": <ArrowsOut />,
  "arrows-out-line-horizontal": <ArrowsOutLineHorizontal />,
  "arrows-out-simple": <ArrowsOutSimple />,
  article: <Article />,
  bank: <Bank />,
  bell: <Bell />,
  briefcase: <Briefcase />,
  buildings: <Buildings />,
  "bug-droid": <BugDroid />,
  calendar: <CalendarBlank />,
  "calendar-check": <CalendarCheck />,
  "calendar-dots": <CalendarDots />,
  "calendar-plus": <CalendarPlus />,
  "card-holder": <Cardholder />,
  "caret-down": <CaretDown />,
  "caret-left": <CaretLeft />,
  "caret-right": <CaretRight />,
  "caret-up": <CaretUp />,
  certificate: <Certificate />,
  champagne: <Champagne />,
  "chart-line": <ChartLine />,
  "chat-dots": <ChatDots />,
  chats: <Chats />,
  "chat-text": <ChatText />,
  check: <Check />,
  "check-circle": <CheckCircle />,
  "check-square": <CheckSquare />,
  circle: <Circle />,
  "circle-notch": <CircleNotch />,
  "clipboard-text": <ClipboardText />,
  clock: <Clock />,
  "clock-clockwise": <ClockClockwise />,
  "clock-counter-clockwise": <ClockCounterClockwise />,
  "code-block": <CodeBlock />,
  copy: <Copy />,
  "credit-card": <CreditCard />,
  "currency-circle-dollar": <CurrencyCircleDollar />,
  devicemobile: <DeviceMobile />,
  dot: <Dot />,
  dotdotdot: <DotsThree />,
  "dotdotdot-vertical": <DotsThreeVertical />,
  "dot-outline": <DotOutline />,
  "dots-six-vertical": <DotsSixVertical />,
  download: <DownloadSimple />,
  edit: <PencilSimple />,
  envelope: <Envelope />,
  "envelope-simple-open": <EnvelopeSimpleOpen />,
  eye: <Eye />,
  "eye-closed": <EyeClosed />,
  excel: <FileXls />,
  file: <File />,
  files: <Files />,
  "file-minus": <FileMinus />,
  "file-pdf": <FilePdf />,
  "file-doc": <FileDoc />,
  "file-lock": <FileLock />,
  "file-plus": <FilePlus />,
  "file-text": <FileText />,
  "file-x": <FileX />,
  "file-xls": <FileXls />,
  "flag-norway": "\uD83C\uDDF3\uD83C\uDDF4",
  "flag-sweden": "\uD83C\uDDF8\uD83C\uDDEA",
  "flag-checkered": <FlagCheckered />,
  flask: <Flask />,
  folder: <FolderNotch />,
  "folder-lock": <FolderLock />,
  "folder-open": <FolderOpen />,
  "folder-plus": <FolderPlus />,
  folders: <Folders />,
  gavel: <Gavel />,
  gear: <Gear />,
  gift: <Gift />,
  "git-commit": <GitCommit />,
  "git-fork": <GitFork />,
  globe: <Globe />,
  "google-logo": <GoogleLogo />,
  graph: <Graph />,
  grid: <GridNine />,
  hand: <Hand />,
  handshake: <Handshake />,
  hash: <Hash />,
  hourglass: <Hourglass />,
  house: <House />,
  houseline: <HouseLine />,
  "identification-card": <IdentificationCard />,
  info: <Info />,
  lightbulb: <Lightbulb />,
  lightning: <Lightning />,
  "lightning-a": <LightningA />,
  link: <Link />,
  list: <List />,
  "list-bullets": <ListBullets />,
  "list-checks": <ListChecks />,
  "list-magnifying-glass": <ListMagnifyingGlass />,
  "list-numbers": <ListNumbers />,
  "list-star": <ListStar />,
  "list-plus": <ListPlus />,
  lock: <LockSimple />,
  "lock-key": <LockKey />,
  "magic-wand": <MagicWand />,
  "magnifying-glass": <MagnifyingGlass />,
  "magnifying-glass-minus": <MagnifyingGlassMinus />,
  "magnifying-glass-plus": <MagnifyingGlassPlus />,
  "map-pin": <MapPin />,
  "map-pin-area": <MapPinSimpleArea />,
  megaphone: <Megaphone />,
  "microsoft-outlook-logo": <MicrosoftOutlookLogo />,
  "microsoft-excel-logo": <MicrosoftExcelLogo />,
  minus: <Minus />,
  money: <Money />,
  monitor: <Monitor />,
  notebook: <Notebook />,
  "note-pencil": <NotePencil />,
  "paint-brush": <PaintBrush />,
  paperclip: <Paperclip />,
  "paper-plane": <PaperPlaneTilt />,
  "paint-brush-broad": <PaintBrushBroad />,
  parachute: <Parachute />,
  peace: <Peace />,
  pen: <Pen />,
  person: <Person />,
  phone: <Phone />,
  plugs: <Plugs />,
  plus: <Plus />,
  "potted-plant": <PottedPlant />,
  printer: <Printer />,
  question: <Question />,
  receipt: <Receipt />,
  rocket: <RocketLaunch />,
  rows: <Rows />,
  scroll: <Scroll />,
  "seal-check": <SealCheck />,
  "shopping-cart-simple": <ShoppingCartSimple />,
  "sidebar-simple": <SidebarSimple />,
  "sign-out": <SignOut />,
  signature: <Signature />,
  "sort-ascending": <SortAscending />,
  "sort-descending": <SortDescending />,
  sparkle: <Sparkle />,
  star: <Star />,
  suitcaseSimple: <SuitcaseSimple />,
  "stack-minus": <StackMinus />,
  swap: <Swap />,
  table: <Table />,
  "text-bolder": <TextBolder />,
  "text-italic": <TextItalic />,
  "text-lines": <TextAlignLeft />,
  "thumbs-up": <ThumbsUp />,
  "thumbs-down": <ThumbsDown />,
  trash: <Trash />,
  upload: <UploadSimple />,
  user: <User />,
  "user-circle": <UserCircle />,
  "user-circle-gear": <UserCircleGear />,
  "user-circle-plus": <UserCirclePlus />,
  "user-minus": <UserMinus />,
  "user-plus": <UserPlus />,
  "user-list": <UserList />,
  "user-square": <UserSquare />,
  "user-switch": <UserSwitch />,
  users: <Users />,
  "users-three": <UsersThree />,
  unite: <Unite />,
  "video-camera": <VideoCamera />,
  wallet: <Wallet />,
  warning: <Warning />,
  "warning-circle": <WarningCircle />,
  webcam: <Webcam />,
  x: <X />,
  "x-circle": <XCircle />,
  "x-square": <XSquare />,
  "paper-plane-tilt": <PaperPlaneTilt />,
};

export type IconName = keyof typeof iconMap;
